module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getBlockModifiers(),
    on: {
      "click": _vm.toggleButtons
    }
  }, [_c('div', {
    class: [_vm.block + '-label']
  }, [_vm._v(_vm._s(_vm.data.leftLabel))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-container']
  }, [_c('div', {
    class: [_vm.block + '-button', {
      'm-right': _vm.right
    }]
  })]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-label']
  }, [_vm._v(_vm._s(_vm.data.rightLabel))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-434d34ca","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/Slider.vue
// module id = 444
// module chunks = 0